import { apiRequest } from './apiUtils';
import { CreateContentPortfolioRequestDto, CreateContentPortfolioResponseDto } from '@foodfluence/shared';

// Type definition for ContentPortfolioDto
export interface ContentPortfolioDto {
  contentId: string;
  brand: string;
  postLink: string;
  contentType: 'image' | 'video';
  downloadUrl: string;
  createdAt: string;
}

export const contentPortfolioApi = {
  createPortfolioContent: async (data: CreateContentPortfolioRequestDto, influencerId: string): Promise<CreateContentPortfolioResponseDto> => {
    return apiRequest<CreateContentPortfolioResponseDto>({
      method: 'POST',
      endpoint: '/content-portfolio',
      data,
      influencerId,
    });
  },

  confirmUpload: async (contentId: string, influencerId: string): Promise<{ success: boolean }> => {
    return apiRequest<{ success: boolean }>({
      method: 'PATCH',
      endpoint: `/content-portfolio/${contentId}/confirm`,
      influencerId,
    });
  },

  getPortfolioContent: async (influencerId: string): Promise<ContentPortfolioDto[]> => {
    const response = await apiRequest<{ success: boolean; portfolio: ContentPortfolioDto[] }>({
      method: 'GET',
      endpoint: '/content-portfolio',
      influencerId,
    });
    return response.portfolio;
  },

  deletePortfolioContent: async (contentId: string, influencerId: string): Promise<{ success: boolean }> => {
    return apiRequest<{ success: boolean }>({
      method: 'DELETE',
      endpoint: `/content-portfolio/${contentId}`,
      influencerId,
    });
  },
};
